import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
interface ITabsProps {
  tabs: string[];
  selectedTab: number;
  setSelectedTab: React.Dispatch<React.SetStateAction<number>>;
}
const Tabs = ({ tabs, selectedTab, setSelectedTab }: ITabsProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <div className="flex gap-4 mt-4">
      {tabs.map((x, i) => {
        return (
          <button
            key={i}
            onClick={() =>
              x === "My Auctions" && location.pathname === "/account"
                ? navigate("/my-auctions")
                : setSelectedTab(i)
            }
            className={`border-gray-500 border-2 ${
              i === selectedTab ? "bg-blue-400" : ""
            }`}
          >
            {x}
          </button>
        );
      })}
    </div>
  );
};

export default Tabs;
